<template>
  <div class="talk base-pad">
    <div class="title">
      <img :src="zh_en == 'zh' ? STATICURL + bgimg.talk_bgimg : STATICURL + talk_bgimg_en"
        style="width: 100%;height: 100%;" alt="">

    </div>


    <div class="content">


      <img src="../static/images/talkBack.png" style="width: 100%; position: absolute;bottom: 0;left: 0;" alt="">

      <div class="detail">

        <div class="titlebox">
          <div style="color: #8a2e26;font-size: 28px;font-weight: bold;"> {{ zh_en == 'zh' ? '联系我们' : 'Contact Us' }}
          </div>
          <div style="display: flex;">
            <div class="default" :class='activityIndex == index ? "activity" : ""' v-for="(item, index) in tabList"
              :key="index" @click="change(index)">{{ item }}</div>
          </div>

          <img src="@/static/images/cultureTitile.png" style="width: 100%;position: absolute;bottom: 0;left: 0;"
            mode="widthFix" />
        </div>

        <div class="contentbox">

          <div
            style="display: flex;flex-direction: column;justify-content: center;align-items: center;margin-bottom: 24px;">
            <div style="color: #181818; font-size: 28px;font-weight: 600;margin-bottom: 5px;margin-top: 15px;">{{
              tabList[activityIndex] }}</div>
            <div style="width: 82px;height: 7px;border-radius: 3px;background-color: #8a2e26;"></div>
          </div>




          <div v-if="activityIndex == 0">
            <div style="display: flex;align-items: center;">
              <div style="width: 6px;height: 28px;background-color: #8a2e26;margin-right: 10px;"></div>

              <div style="color: #8a2e26;font-size: 22px;font-weight: 600;text-align: left;">{{ hotline.title }}

              </div>
            </div>
            <!-- hotline -->
            <div v-html="hotline.content"></div>


          </div>


          <div v-if="activityIndex == 1">

            <div class="form-container">
              <div class="form-title">{{ zh_en == 'zh' ? '如果您有什么建议或意见，可以及时反馈给我们！' : 'If you have any suggestions or feedback, please feel free to share them with us in a timely manner.' }}</div>
              <!-- <form> -->
              <div style="display: flex;justify-content: space-between;">
                <div style="width: 49%;">
                  <div class="form-group">
                    <label for="name"> {{ zh_en == 'zh' ? '您的姓名' : 'your name' }}</label>
                    <input type="text" id="name" name="name" v-model="postdata.name" required>
                  </div>
                  <div class="form-group">
                    <label for="company"> {{ zh_en == 'zh' ? '您的公司' : 'your company' }}</label>
                    <input type="text" id="company" v-model="postdata.company" name="company">
                  </div>
                  <div class="form-group">
                    <label for="phone"> {{ zh_en == 'zh' ? '您的电话' : 'your phone' }}</label>
                    <input type="tel" id="phone" name="phone" v-model="postdata.phone" required>
                  </div>
                </div>
                <div class="form-group" style="width: 49%;display: flex;flex-direction: column;">
                  <label for="remarks"> {{ zh_en == 'zh' ? '备注' : 'remark' }}</label>
                  <textarea id="remarks" name="remarks" v-model="postdata.remark" style="flex: 1;"></textarea>
                </div>
              </div>
              <button @click="sub_online" class="submit-btn"> {{ zh_en == 'zh' ? '提交' : 'submit' }}</button>
              <!-- </form> -->
            </div>

          </div>


          <div v-if="activityIndex == 2">

            <div style="display: flex;align-items: center;">
              <div style="width: 6px;height: 28px;background-color: #8a2e26;margin-right: 10px;"></div>

              <div style="color: #8a2e26;font-size: 22px;font-weight: 600;text-align: left;">{{ recruitment.title }}

              </div>
            </div>
            <!-- recruitment -->
            <div v-html="recruitment.content"></div>


          </div>
        </div>



      </div>

    </div>

    <HomeFooter />
  </div>
</template>

<script>
// get_hotline
import HomeFooter from '@/components/HomeFooter.vue';
import {
  get_hotline,
  get_recruitment,
  sub_online
} from "@/api/api";
export default {
  data() {
    return {
      tabList: this.zh_en == 'zh' ? ['举报热线', '在线留言', '人才招聘'] : ['AlertLine', 'Message', 'Recruitment'],
      activityIndex: 0,
      hotline: '',
      recruitment: '',
      isOne: true,
      postdata: {
        zh_en: 'zh',
        name: '',
        phone: '',
        remark: '',
        company: ''
      }
    }
  },
  components: {
    HomeFooter
  },
  mounted() {
    this.change(0)
  },
  methods: {
    sub_online() {
      if (!this.isOne) return
      this.isOne = false
      if (this.postdata.name == '' || this.postdata.phone == '') {
        this.$message({
          message: this.zh_en == 'zh' ? '您的姓名和电话不能为空' : 'Your name and phone number are required',
          type: 'warning'
        });
        setTimeout(() => {
          this.isOne = true
        }, 1000);
        return
      }

      sub_online(this.postdata).then(() => {
        this.$message({
          message: this.zh_en == 'zh' ? '提交成功，感谢您的反馈' : 'Submission successful. Thank you for your feedback',
          type: 'success'
        });
        setTimeout(() => {
          this.postdata = {
            zh_en: 'zh',
            name: '',
            phone: '',
            remark: '',
            company: ''
          }
          this.isOne = true
        }, 2000);
      })
    },
    change(e) {
      this.activityIndex = e
      if (e == 0) {
        this.get_hotline()
      }
      if (e == 2) {
        this.get_recruitment()
      }
    },
    get_recruitment() {
      get_recruitment().then(res => {
        this.recruitment = res
      })
    },
    get_hotline() {
      get_hotline().then(res => {
        this.hotline = res
      })
    }
  }

}
</script>


<style lang="less" scoped>
.form-container {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  width: 100%;
  box-sizing: border-box;
}

.form-title {
  text-align: center;
  margin-bottom: 20px;
  color: #333;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  color: #555;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.form-group textarea {
  resize: vertical;
  height: 100px;
}

.submit-btn {
  width: 100%;
  padding: 10px;
  background-color: #a52a2a;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
}

.submit-btn:hover {
  background-color: #8b2222;
}

.default {
  font-size: 15px;
  padding: 2px 0;
  display: flex;
  align-items: center;
  margin-left: 35px;
}

.activity {
  font-size: 17px;
  color: #8A2E26;
  border-bottom: 1px solid #8A2E26;
}

.content {
  width: 100%;
  padding: 48px;
  position: relative;

  box-sizing: border-box;

  .detail {
    position: relative;

    .titlebox {
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;
      padding-bottom: 30px;
    }

    width: 60%;
    margin: 0 auto;
  }
}

.culture {}

.title {
  width: 100%;
  height: 360px;
  background-color: #d3dce6;

}
</style>